module.exports = __webpack_public_path__ + "static/media/footer-bnr_1920x30.fdb6e6d2.png";